export const FILES_LEGAL = 'FILES_LEGAL'
export const FILES_CREDIT = 'FILES_CREDIT'
export const FILES_PROJECT = 'FILES_PROJECT'
export const FILES_REVIEW = 'FILES_REVIEW'
export const FILES_ORDER = 'FILES_ORDER'
export const FILES_RESET = 'FILES_RESET'

export default {
    FILES_LEGAL,
    FILES_CREDIT,
    FILES_PROJECT,
    FILES_REVIEW,
    FILES_ORDER,
    FILES_RESET
}
